var banner_button = $('#collapse_button');
var banner_wrapper = $('#collapse_content_wrapper');
var banner_button_wrapper = $('#collapse_buttons_wrapper');

$(banner_button).click(function (e) { 
    e.preventDefault();
    if($(banner_wrapper).hasClass('open')) {
      $(banner_wrapper).removeClass('open');
      $(banner_wrapper).height('0');
    } else {
      $(banner_wrapper).addClass('open');
     $(banner_wrapper).outerHeight(banner_button_wrapper.outerHeight(true));
    }
        
});

$(document).ready(function () {

  $('#custom-email-loyalty').click(function (e) { 
    e.preventDefault();
    var email_value = $('input[name="contact[email]"]').val();
    window.location.href = "https://mph-b2c.myshopify.com/a/loyalty?email=" + email_value;
    
  });

   if (window.location.href.indexOf("/loyalty") !== -1) {
var urlParams = new URLSearchParams(window.location.search);
    
    if (urlParams.has('email')) {
        var email = urlParams.get('email');
        
        console.log('Email:', email);
        
        // You can use the email value as needed, for example:
        $("#email").val(email);
        // alert("Email: " + email); // Display an alert with the email value
    } else {
        console.log('Email parameter not found in the URL.');
    }
}
  
if ($(window).width() < 600) {
         $($('.search-form__container')).appendTo($('#SiteHeader .page-width'));
    } 
});